// Analytics Configuration
// Replace 'GA_MEASUREMENT_ID' with your actual GA4 Measurement ID from Google Analytics

export const ANALYTICS_CONFIG = {
  // Primary Google Analytics 4 Measurement ID
  measurementId: 'G-QDPGQ9XPCV',

  // Dedicated GA4 property for detailed cart/KRA reporting
  secondaryMeasurementId: 'G-KJCL15E0C8',
  
  // Environment settings
  isProduction: process.env.NODE_ENV === 'production',
  enableDebugLogging: process.env.NODE_ENV === 'development',
  
  // Custom tracking settings
  trackingEnabled: true,
  
  // Custom events configuration
  events: {
    cafe_selection: 'cafe_selected',
    menu_view: 'menu_viewed',
    first_page_load: 'first_page_load',
    app_load: 'app_loaded',
    engagement_time: 'engagement_time',
    cart_feature_available: 'cart_feature_available',
    cart_opened: 'cart_opened',
    cart_closed: 'cart_closed',
    cart_step_viewed: 'cart_step_viewed',
    cart_table_completed: 'cart_table_completed',
    cart_phone_completed: 'cart_phone_completed',
    cart_phone_captured: 'cart_phone_captured',
    cart_phone_skipped: 'cart_phone_skipped',
    cart_summary_viewed: 'cart_summary_viewed',
    cart_summary_edit_clicked: 'cart_summary_edit_clicked',
    cart_order_done: 'cart_order_done',
    cart_item_quantity_changed: 'cart_item_quantity_changed',
    cart_item_replaced: 'cart_item_replaced',
    cart_cleared: 'cart_cleared',
    cart_customization_chooser_viewed: 'cart_customization_chooser_viewed',
    cart_customization_add_new_clicked: 'cart_customization_add_new_clicked',
    cart_customization_edit_clicked: 'cart_customization_edit_clicked',
    cart_expiry_warning_shown: 'cart_expiry_warning_shown',
    cart_expiry_dismissed: 'cart_expiry_dismissed',
    cart_conversion_completed: 'cart_conversion_completed',
    cart_abandoned: 'cart_abandoned'
  }
};

// Instructions:
// 1. Go to https://analytics.google.com
// 2. Create a new GA4 property for your BTC Cafe Menu
// 3. Get your Measurement ID (starts with G-)
// 4. Replace 'GA_MEASUREMENT_ID' above with your actual ID
// 5. Also update the GA_MEASUREMENT_ID in public/index.html with the same ID
